import React from 'react';
import Layout from '../../../components/Layout';
import ServicesLayout from '../../../components/ServicesLayout';
import Districts from './Districts';
import stepperWrapper from '../../../hocs/stepperWrapper';
import layoutWrapper from '../../../hocs/layoutWrapper';
import StepClass from '../../../classes/StepClass';

const title = 'Zarządzanie Urzędami';

import { isAdminUser } from '../../../lib/utils';

export default {

  path: '/districts',
  children: [
    {
      path: '/',
      async action(ctx) {
        const isAdmin = await isAdminUser(ctx);
        if (!isAdmin) {
          return { redirect: '/' };
        }
        const component = stepperWrapper(<Districts title={title} />, [
          new StepClass('/admin', 'Admin'),
          new StepClass('/districts', 'Gminy'),
        ]);
        // <ServicesLayout isAdmin>{component}</ServicesLayout>
        return {
          title,
          chunk: 'districts',
          component: layoutWrapper({ isAdmin }, component),
        };
      },
    },
    require('./add_district').default,
    require('./edit_district').default,
  ]
};



// WEBPACK FOOTER //
// src/routes/admin/districts/index.js